// extracted by css-extract-rspack-plugin
export default {"unit":"Unit_unit__XTdYO"};